import React, { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector, useDispatch } from "react-redux";
import { countryActions } from "../../../redux/actions/guides";
import { SimpleModal, MyInput, DialogModal } from "../../../components";
import * as Yup from "yup";
import DeleteIcon from '@material-ui/icons/Delete';
import { Button } from "@material-ui/core";
import useToggle from "../../../hooks/useToggle";
import { useStateIfMounted } from "use-state-if-mounted";

const defaultValues = {
  nameCountry: "",
  fullNameCountry: "",
  symbolCountry: "",
  digitalCountry: "",
};

const validationSchema = Yup.object().shape({
  nameCountry: Yup.string().max(255, "Превышено максимальное кол-во символов(255)").required("Обязательное для заполнения поле"),
  fullNameCountry: Yup.string().max(255, "Превышено максимальное кол-во символов(255)").required("Обязательное для заполнения поле"),
  symbolCountry: Yup.string().max(255, "Превышено максимальное кол-во символов(255)").nullable(),
  digitalCountry: Yup.string().max(255, "Превышено максимальное кол-во символов(255)").nullable(),
});

export const ModalCountry = ({ modalShow, onClose, isAddMode, setIsAddMode, id, refresh = () => {} }) => {
  const dispatch = useDispatch();
  const { item, loadingItem, fetchedItem, deleted } = useSelector((state) => state.guides.countries);

  const [deleteDialog, setDeleteDialog] = useStateIfMounted(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
    clearErrors,
    setValue,
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: defaultValues,
  });

  const onSubmit = async (data) => {
    // return isAddMode ? dispatch(countryActions.create(data)) : dispatch(countryActions.update(id, data));

    try {
      let result;
      if (isAddMode) {
        result = await dispatch(countryActions.create(data));
      } else {
        result = await dispatch(countryActions.update(item.id, data));
      }
    }
    catch (error) {
      return;
    }

    setIsAddMode(false);
    
  };

  useEffect(() => {
    if (!modalShow || isAddMode) return;

    dispatch(countryActions.getById(id));

    return () => dispatch({ type: "RESET_ITEM_COUNTRIES" });
  }, [modalShow]);

  useEffect(() => {
    if (!fetchedItem || isAddMode) return;

    Object.keys(defaultValues).forEach((field) => setValue(field, item[field]));
  }, [item, fetchedItem]);

  const handleDeleteClick = useCallback((id) => {
    dispatch(countryActions.delete(id));
    setDeleteDialog(false);
  }, [dispatch, setDeleteDialog]);

  // Эффект для обработки успешного удаления
  useEffect(() => {
    if (deleted && modalShow) {
      setDeleteDialog(false);
      closeModalFunc();
      onClose();
      refresh();
      console.log('Страна успешно удалена');
    }
  }, [deleted]);

   const closeModalFunc = () => {
    clearErrors();
    reset(defaultValues);
  };

  return (
    <div>
      <SimpleModal
        modalTitle={isAddMode ? "Новая страна" : "Редактирование"}
        winPermissionName="Общие"
        modalShow={modalShow}
        modalSize="sm"
        fullScreen={false}
        loading={loadingItem}
        isAddMode={isAddMode}
        status={!isAddMode}
        operations={item}
        onSubmit={handleSubmit(onSubmit)}
        onClose={() => {
          onClose();
          clearErrors();
          reset(defaultValues);
        }}
      >
        <form noValidate>
          <MyInput name="nameCountry" control={control} label="Краткое наименование" required errors={errors?.nameCountry} />
          <MyInput name="fullNameCountry" control={control} label="Полное наименование" required errors={errors?.fullNameCountry} />
          <MyInput name="digitalCountry" control={control} label="Цифровой код" errors={errors?.digitalCountry}/>
          <MyInput name="symbolCountry" control={control} label="Буквенный код" errors={errors?.symbolCountry}/>
          <Button
            disabled={!isAddMode && item?.id === null || item?.id === undefined}
            aria-describedby={id}
            size="small"
            color="primary"
            onClick={() => setDeleteDialog(true)}
            startIcon={<DeleteIcon />}
          >
            Удалить
          </Button>
        </form>
      </SimpleModal>
      <DialogModal
        open={deleteDialog}
        onConfirmDialogClose={() => setDeleteDialog(false)}
        onYesClick={() => handleDeleteClick(item?.id)}
        text={`Вы действительно хотите удалить страну - ${item?.nameCountry}? Это действие невозможно отменить.`}
      />
    </div>
  );
};